import React from "react";
import styles from "./DynamicForm.module.scss";
import MultiStepForm from "./components/MultiStepForm";
import SimpleForm from "./components/SimpleForm";

/**
 * Dynamic Form Main Component
 * The display is based on form.type_id: 
 * 1 => stepper (MultiStepForm)
 * 2 => stacked (SimpleForm)
*/

const DynamicForm = (props) => {
    const { form, text_alignment_content } = props;

    return (
        <div className={`${styles.DynamicForm ?? ""} text-${text_alignment_content ? text_alignment_content : "start"}`}>
            {form.type_id === 1 ? (
                <MultiStepForm data={form} />
            ) : form.type_id === 2 ? (
                <SimpleForm data={form} />
            ) : (
                // Fallback: If none of the types are available
                <SimpleForm data={form} />
            )}
        </div>
    );
};

export default DynamicForm;
